import { useCallback } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";

const useQueryStringParams = () => {
	const nav = useNavigate();
	const location = useLocation();
	const [urlSearchParams, setUrlSearchParams] = useSearchParams();

	const setQueryParam = useCallback((key: string, value?: string) => {
		const params = new URLSearchParams(urlSearchParams.toString());
		
		if (key && value) {
			params.set(key, value);
		} else if (key) {
			params.delete(key);
		}

		setUrlSearchParams(params.toString());
	}, [setUrlSearchParams, urlSearchParams]);

	const getQueryParam = useCallback((key: string) => {
		const params = new URLSearchParams(urlSearchParams.toString());
		return params.get(key);
	}, [urlSearchParams]);

	const navigateWithParam = useCallback((path: string, key: string, value: string) => {
		const params = new URLSearchParams(urlSearchParams.toString());
		
		if (key && value) {
			params.set(key, value);
		} else if (key) {
			params.delete(key);
		}

		// If we're already at the given path, stay here and just set the query param
		if (location.pathname === path) {
			setUrlSearchParams(params.toString());
		} else {
			console.log(`Navigating to ${path}?${params.toString()}`);
			nav({ pathname: path, search: params.toString() });
		}
	}, [location.pathname, nav, setUrlSearchParams, urlSearchParams]);

	return { getQueryParam, setQueryParam, navigateWithParam };
};

export default useQueryStringParams;